export default __webpack_public_path__ + "static/media/icone-visualizar-senha.2d0852a3.svg";